/**
 * LACOMUS - Vision motion layer.
 * Scroll reveals ([data-lacv-reveal]) and count-up numbers ([data-lacv-count]).
 * GPU-only (opacity/transform), skipped for reduced motion and inside the
 * theme editor so blocks never hide while being edited.
 */
(() => {
  if (window.LacomusVision) return;

  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const editing = Boolean(window.Shopify && window.Shopify.designMode);
  const animate = !reduced && !editing && 'IntersectionObserver' in window;

  function countUp(el) {
    if (el.dataset.lacvCounted) return;
    el.dataset.lacvCounted = 'true';
    const raw = (el.dataset.lacvCount || '').trim();
    // Only plain numbers count up; ranges like "6–8" stay as typed.
    if (!animate || !/^\d+(\.\d+)?$/.test(raw)) return;
    const target = parseFloat(raw);
    const decimals = (raw.split('.')[1] || '').length;
    const start = performance.now();
    const duration = 1100;
    const step = (now) => {
      const p = Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      el.textContent = (target * eased).toLocaleString('en-PH', {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
      });
      if (p < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  }

  function reveal(el) {
    el.classList.add('is-revealed');
    el.querySelectorAll('[data-lacv-count]').forEach(countUp);
  }

  const observer = animate
    ? new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            observer.unobserve(entry.target);
            reveal(entry.target);
          });
        },
        { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
      )
    : null;

  function scan(root) {
    const scope = root && root.querySelectorAll ? root : document;
    let index = 0;
    scope.querySelectorAll('[data-lacv-reveal]:not(.is-revealed)').forEach((el) => {
      if (!observer) return reveal(el);
      if (!el.style.getPropertyValue('--lacv-delay')) {
        el.style.setProperty('--lacv-delay', `${Math.min(index, 6) * 70}ms`);
        index += 1;
      }
      observer.observe(el);
    });
  }

  if (animate) document.documentElement.classList.add('lacv-motion');

  const start = () => scan(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();

  document.addEventListener('shopify:section:load', (event) => scan(event.target));
  document.addEventListener('shopify:block:select', (event) => event.target && reveal(event.target));

  window.LacomusVision = { scan, reveal };
})();
